import { getResponsiveStyles, mergeStyles } from '../../../component-themes';
const productTitleSublineBase = (tokens) => ({ size, variant, }) => mergeStyles([
    {
        margin: 0,
        color: tokens.styles[`productTitle-subline-base-${variant}-${size}-color`],
        fontSize: tokens.styles[`productTitle-subline-base-${variant}-${size}-fontSize`],
        fontWeight: tokens.styles[`productTitle-subline-base-${variant}-${size}-fontWeight`],
        fontFamily: tokens.styles[`productTitle-subline-base-${variant}-${size}-fontFamily`],
        lineHeight: tokens.styles[`productTitle-subline-base-${variant}-${size}-lineHeight`],
        letterSpacing: tokens.styles[`productTitle-subline-base-${variant}-${size}-letterSpacing`],
        opacity: tokens.styles[`productTitle-subline-base-${variant}-${size}-opacity`],
    },
]);
export const productTitleSubline = (tokens) => ({ size, variant, }) => getResponsiveStyles(size, (size) => productTitleSublineBase(tokens)({ size, variant }));
